<script setup lang="ts">
import { Breadcrumb, BreadcrumbItem, BreadcrumbList, BreadcrumbSeparator } from '@/components/ui/breadcrumb'
import { ChevronRight } from 'lucide-vue-next'

export interface BreadcrumbData {
  text: string
  to?: string | (() => void)
}

defineProps<{
  breadcrumbs: BreadcrumbData[]
}>()
</script>

<template>
  <Breadcrumb>
    <BreadcrumbList class="gap-x-0.5">
      <BreadcrumbItem v-for="(breadcrumb, index) in breadcrumbs" :key="index" class="gap-x-0.5">
        <template v-if="index < breadcrumbs.length - 1">
          <button
            v-if="typeof breadcrumb.to === 'function'"
            class="text-zinc-500 max-w-[300px] truncate"
            :title="breadcrumb.text"
            @click="breadcrumb.to"
          >
            {{ breadcrumb.text }}
          </button>

          <NuxtLink v-else :to="breadcrumb.to" class="text-zinc-500 max-w-[300px] truncate" :title="breadcrumb.text">
            {{ breadcrumb.text }}
          </NuxtLink>
        </template>
        <template v-else>
          <span class="font-medium max-w-[300px] truncate" :title="breadcrumb.text">{{ breadcrumb.text }}</span>
        </template>

        <BreadcrumbSeparator v-if="index < breadcrumbs.length - 1">
          <ChevronRight class="w-4 ml-1" />
        </BreadcrumbSeparator>
      </BreadcrumbItem>
    </BreadcrumbList>
  </Breadcrumb>
</template>
